// extracted by mini-css-extract-plugin
module.exports = {"geozoneTitle":"index_geozoneTitle_3IbqH","geozoneName":"index_geozoneName_2feu3","name":"index_name_1tYtW","icon":"index_icon_hiqr-","wrapper":"index_wrapper_a-IK6"};